/* eslint-disable no-console */
const canPrefetch = () => {
  const c = (navigator as any).connection

  if (c?.saveData) return false

  return !c?.effectiveType || c.effectiveType === '4g'
}

export const prefetchLink = (href: string) => {
  if (!href || document.querySelector(`link[rel="prefetch"][href="${href}"]`)) return

  const l = document.createElement('link')

  l.rel = 'prefetch'
  l.href = href
  document.head.appendChild(l)
}

export const attachInViewPrefetch = (node: Element | null, href: string) => {
  if (!node) return

  let done = false
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (done || !e.isIntersecting || !canPrefetch()) return

      // schedule lightly
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => prefetchLink(href))
      } else {
        setTimeout(() => prefetchLink(href), 0)
      }
      done = true
    })
  }, { rootMargin: '400px' })

  io.observe(node)

  return () => io.disconnect()
}
